import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import {
  Container,
  Tabs,
  Tab,
  Box,
  Typography,
} from '@mui/material';
import EmployeesManagement from '../components/admin/EmployeesManagement';
import ProjectsManagement from '../components/admin/ProjectsManagement';
import DepartmentsManagement from '../components/admin/DepartmentsManagement';
import WorkTypesManagement from '../components/admin/WorkTypesManagement';
import MaterialsManagement from '../components/admin/MaterialsManagement';
import { useTranslation } from 'react-i18next';

const AdminPanel: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [value, setValue] = useState(() => {
    const path = location.pathname;
    if (path.includes('/employees')) return 0;
    if (path.includes('/projects')) return 1;
    if (path.includes('/departments')) return 2;
    if (path.includes('/work-types')) return 3;
    if (path.includes('/materials')) return 4;
    return 0;
  });

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        {t('admin.adminPanel')}
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={value} onChange={(e, newValue) => setValue(newValue)}>
          <Tab label={t('admin.employees')} component={Link} to="/admin/employees" />
          <Tab label={t('admin.projects')} component={Link} to="/admin/projects" />
          <Tab label={t('admin.departments')} component={Link} to="/admin/departments" />
          <Tab label={t('admin.workTypes')} component={Link} to="/admin/work-types" />
          <Tab label={t('admin.materials')} component={Link} to="/admin/materials" />
        </Tabs>
      </Box>
      <Routes>
        <Route path="employees" element={<EmployeesManagement />} />
        <Route path="projects" element={<ProjectsManagement />} />
        <Route path="departments" element={<DepartmentsManagement />} />
        <Route path="work-types" element={<WorkTypesManagement />} />
        <Route path="materials" element={<MaterialsManagement />} />
      </Routes>
    </Container>
  );
};

export default AdminPanel;



